<template>
  <modal
    class="s-toast"
    :class="[{ confirm: showCancel && !$isNoE(cancelText), 'has-icon': !$isNoE(icon) }]"
    ref="modalRef"
    :animation="$deviceComputes.isMobileOrTablet.value ? 'bottom-slide-in' : 'bottom-fade-in'"
    :closable="closable"
    :sticky="sticky"
    @close-click="onCloseClick"
    @closed="onClosed"
  >
    <div class="s-toast__content" :class="[{ centered }]" v-html="message" />
  </modal>
</template>

<script>
import { computed, reactive, toRefs, watch, onMounted, onUnmounted } from 'vue';

export default {
  name: 'Toast',
  props: {
    fields: {
      type: Object,
    },
  },
  setup(props) {
    let timeout = null;
    const state = reactive({
      /**@type ModalRef*/
      modalRef: null,
      closable: false,
      centered: false,
      sticky: true,
      icon: null,
      message: null,
      showOk: false,
      okText: null,
      showCancel: false,
      cancelText: null,
      onOk() {},
      onCloseClick() {},
      onCancel() {},
      onClosed() {},
    });
    const computes = {
      okProps: computed(() => ({
        fields: {
          theme: {
            fields: {
              phrase: {
                value: 'black-empty',
              },
            },
          },
          text: {
            value: state.okText,
          },
          type: {
            fields: {
              phrase: {
                value: 'primary-button',
              },
            },
          },
        },
      })),
      cancelProps: computed(() => ({
        fields: {
          theme: {
            fields: {
              phrase: {
                value: 'light',
              },
            },
          },
          text: {
            value: state.cancelText,
          },
          type: {
            fields: {
              phrase: {
                value: 'tertiary-button',
              },
            },
          },
        },
      })),
    };
    // 澶勭悊閿洏浜嬩欢
    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        console.log('ESC pressed', {
          hasModalRef: !!state.modalRef,
          modalShow: state.modalRef?.show,
          closable: state.closable,
        });

        if (state.modalRef && state.modalRef.show && state.closable) {
          event.preventDefault();
          console.log('Closing toast via ESC');
          state.onCloseClick && state.onCloseClick();
        }
      }
    };

    // 缁勪欢鎸傝浇鍜屽嵏杞芥椂绠＄悊浜嬩欢鐩戝惉鍣?
    onMounted(() => {
      document.addEventListener('keydown', handleKeydown);
    });

    onUnmounted(() => {
      document.removeEventListener('keydown', handleKeydown);
      if (timeout) {
        clearTimeout(timeout);
      }
    });

    const methods = {
      open(options) {
        state.icon = options?.icon;
        state.message = options?.message;
        state.closable = options?.closable ?? false;
        state.showOk = options?.showOk ?? false;
        state.showCancel = options?.showCancel ?? false;
        state.okText = options?.okText ?? null;
        state.cancelText = options?.cancelText ?? null;
        state.centered = !!options?.centered;
        state.sticky = options?.sticky ?? false;
        state.onOk = () => {
          if (timeout) {
            clearTimeout(timeout);
          }
          state.modalRef.close();
          options?.onOk && options?.onOk();
        };
        state.onCancel = () => {
          if (timeout) {
            clearTimeout(timeout);
          }
          state.modalRef.close();
          options?.onCancel && options?.onCancel();
        };
        state.onCloseClick = () => {
          if (timeout) {
            clearTimeout(timeout);
          }
          state.modalRef.close();
          options?.onCancel && options?.onCancel();
        };
        state.onClosed = () => {
          options?.onClosed && options?.onClosed();
        };
        state.modalRef.open();
        if (!isNaN(options.duration)) {
          if (timeout) {
            clearTimeout(timeout);
          }
          timeout = setTimeout(() => {
            state.modalRef.close();
          }, options.duration ?? 3600);
        }
        return {
          updateMessage(message) {
            state.message = message;
          },
          close() {
            state.modalRef.close();
          },
        };
      },
      onOkClick(e) {
        state.onOk && state.onOk(e);
      },
      onCancelClick(e) {
        state.onCancel && state.onCancel(e);
      },
    };
    return {
      ...toRefs(state),
      ...computes,
      ...methods,
    };
  },
};
</script>

<style lang="scss">
@import '../styles/variables';
@import '../styles/functions';
@import '../styles/mixins';
.s-toast {
  $c: &;
  $m: '.e-modal';
  &.e-modal {
    align-items: center;
  }
  .e-modal {
    &__close {
      top: 20px;
      right: 24px;
      svg {
        width: 18px;
        height: 18px;
      }
    }
    &__content {
      width: 311px;
      padding: 28px 24px 33px 24px;
      // border-radius: 10px;
    }
  }
  &__icon {
    display: flex;
    justify-content: center;
  }
  &__content {
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 24px;
    padding-top: 14px;
    &.centered {
      text-align: center;
    }
  }
  &__buttons {
    margin-top: $space-16;
    display: flex;
    justify-content: space-between;
    .e-site-button {
      height: 40px;
    }
    &.single {
      justify-content: center;
    }
  }
  &__cancel {
    color: $grey !important;
    .e-icon {
      display: none;
    }
  }
  &.confirm {
    #{$c}__buttons {
      .e-site-button {
        width: 50%;
      }
    }
  }
  @include tablet-landscape {
    &.e-modal {
      align-items: center;
    }
    .e-modal {
      &__close {
      }
      &__content {
        width: grid-width(8);
      }
    }
  }
  @include tablet-landscape {
    .e-modal {
      &__content {
        width: grid-width(6);
      }
      &.has-icon {
        #{$m}__content {
          width: grid-width(8);
        }
      }
    }
  }
}
</style>
